import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import LazyModal from 'Components/Utility/LazyModal';
import FluidImg from 'Components/Utility/FluidImg';

export default function ProductMediaModal({
  isOpen,
  onClose,
  carouselType,
  screenshots,
  currentScreenshotNumber,
  onNext,
  onPrevious,
}) {
  const currentScreenshot = screenshots.find(
    slide => slide.screenshotNumber === currentScreenshotNumber,
  );
  const nextScreenshot = screenshots.find(
    slide => slide.screenshotNumber === currentScreenshotNumber + 1,
  );

  return (
    <LazyModal
      open={isOpen}
      setOpen={onClose}
      className="ProductMediaModal"
    >
      <>
        <div className="responsive-image-island">
          <div className="responsive-image responsive-image--16by9">
            <FluidImg
              ratio16by9={carouselType !== 'non game'}
              className="img-force-full top-image"
              src={currentScreenshot.image}
              alt={currentScreenshot.alt}
              sizesOverride="(min-width: 1520px) 1340px, (min-width: 1200px) 1140px, (min-width: 992px) 960px, 90vw"
            />
            {nextScreenshot &&
              <FluidImg
                ratio16by9={carouselType !== 'non game'}
                className="img-force-full bottom-image"
                src={nextScreenshot.image}
                alt={nextScreenshot.alt}
                sizesOverride="(min-width: 1520px) 1340px, (min-width: 1200px) 1140px, (min-width: 992px) 960px, 90vw"
              />
            }
          </div>
        </div>

        <div className="ProductMediaModal__controls">
          <div className="ProductMediaModal__controls__buttonContainer ProductMediaModal__controls__buttonContainer--previous">
            {currentScreenshot.screenshotNumber !== 1 &&
              <button
                className="ProductMediaModal__controls__buttonContainer__button"
                onClick={() => { onPrevious(); }}
              >
                <FormattedMessage id="product-media-carousel.controls.button.previous" defaultMessage="Previous" />
              </button>
            }
          </div>
          <div className="ProductMediaModal__controls__total">
            <FormattedMessage
              id="product-media-carousel.controls.total"
              defaultMessage="{current} of {total} screenshots"
              values={{
                current: currentScreenshot.screenshotNumber,
                total: screenshots.length,
              }}
            />
          </div>
          <div className="ProductMediaModal__controls__buttonContainer ProductMediaModal__controls__buttonContainer--next">
            {currentScreenshot.screenshotNumber !== screenshots.length &&
              <button
                className="ProductMediaModal__controls__buttonContainer__button"
                onClick={() => { onNext(); }}
              >
                <FormattedMessage id="product-media-carousel.controls.button.next" defaultMessage="Next" />
              </button>
            }
          </div>
        </div>
      </>
    </LazyModal>
  );
}

ProductMediaModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  carouselType: PropTypes.string,
  screenshots: PropTypes.arrayOf(PropTypes.object),
  currentScreenshotNumber: PropTypes.number,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
};

ProductMediaModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
  carouselType: '',
  screenshots: [],
  currentScreenshotNumber: 1,
  onNext: () => {},
  onPrevious: () => {},
};
